import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, Observable, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  if (!token) {
    return next(req);
  }

  return from(authService.refreshToken()).pipe(
    switchMap((freshToken) => {
      if (freshToken) {
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${freshToken}` },
        });
        return next(authReq);
      }
      return next(req);
    }),
  );
};
